import { IStore } from 'store/types';
import { PayoutStatus } from 'types';
import { sumBy } from 'utils/arrays';

export const selectPayoutStats = () => (state: IStore) => state.stats?.payouts;

export const selectPayoutStatsByDate = () => (state: IStore) => state.stats?.payouts?.byDate;

export const selectPayoutStatsByStatus = () => (state: IStore) => state.stats?.payouts?.byStatus;

export const selectPayoutStatsStatusCount = (status?: PayoutStatus) => (state: IStore) => {
  const byStatus = (state.stats?.payouts?.byStatus || []).filter((s) => s.status === status);
  return sumBy(byStatus, 'count');
};

export const selectPayoutStatsNetTotal = (status?: PayoutStatus) => (state: IStore) => {
  const byStatus = (state.stats?.payouts?.byStatus || []).filter((s) => s.status === status);
  return sumBy(byStatus, 'net');
};

export const selectReviewPayoutsCount = () => (state: IStore) => state.stats?.counts?.reviewPayouts;

export const selectTipAcceptancePendingPaymentsCount = () => (state: IStore) => state.stats?.counts?.tipAcceptancePendingPayments;

export const selectTipAcceptanceStats = () => (state: IStore) => state.stats?.tipAcceptance;
